import React, { useState } from 'react';
import { Field, useField } from 'formik';
import { FeedPercentageSlider } from './FeedPercentageSlider';

export const FeedPercentage = () => {
  const [field, meta, helpers] = useField({ name: 'feedPercentage' });
  const [state, setState] = useState({
    onlyFeedMyFurbaby: meta.value === 100 || !meta.value,
    percentage: meta.value || 100,
  });

  const { setValue } = helpers;

  const showMixturePercentage = () => {
    const percentage = state.percentage === 100 ? 100 : state.percentage;
    setState({ onlyFeedMyFurbaby: false, percentage: percentage });
    setValue(percentage);
  };

  const hideMixturePercentage = () => {
    setState({ onlyFeedMyFurbaby: true, percentage: 100 });
    setValue(100);
  };

  return (
    <div className="feed-percentage-container">
      <div className="feed-radio-group">
        <div className="feed-radio-item">
          <input
            className="feed-radio-input"
            type="radio"
            name="onlyFeedMyFurbaby"
            id="yes"
            value="yes"
            checked={state.onlyFeedMyFurbaby}
            onChange={hideMixturePercentage}
          />
          <label className="fnt-lt fnt-xs-or" htmlFor="yes">
            Yes, I’ll use mostly My Furbaby
          </label>
        </div>

        <div className="feed-radio-item">
          <input
            className="feed-radio-input"
            type="radio"
            name="onlyFeedMyFurbaby"
            id="no"
            value="no"
            checked={!state.onlyFeedMyFurbaby}
            onChange={showMixturePercentage}
          />
          <label className="fnt-lt fnt-xs-or" htmlFor="no">
            No, I’ll use a mixture of foods
          </label>
        </div>
      </div>

      <div className="feed-percentage-slider-section align-col-cen margin-top-botton-17">
        {!state.onlyFeedMyFurbaby && (
          <div className="feed-percentage-slider-wrapper mgn-top-30">
            <div className="feed-percentage-text fnt-lt fnt-xs-or mgn-bot-10">
              <span className="inside-span-step-3 fnt-lt fnt-xs-or">{state.percentage} % </span> of my dog’s food will be My Furbaby kibble
            </div>
            <FeedPercentageSlider
              setValue={(value) => {
                setValue(value);
                setState((prev) => ({ ...prev, percentage: value }));
              }}
              value={state.percentage}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default FeedPercentage;
